import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IMethodOfTravelToWork {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  workMainlyAtHome?: number | null;
  underground?: number | null;
  train?: number | null;
  bus?: number | null;
  taxi?: number | null;
  motorcycle?: number | null;
  drivingCarVan?: number | null;
  passengerCarVan?: number | null;
  bicycle?: number | null;
  onFoot?: number | null;
  otherMethod?: number | null;
}

export const defaultValue: Readonly<IMethodOfTravelToWork> = {};
